 
import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';

const BookingConfirmation = () => {
    const location = useLocation();
    const { slotDateTime, meetingLink } = location.state || {};

    if (!slotDateTime) {
        return (
            <Container className="py-5">
                <Row className="justify-content-center">
                    <Col md={6}>
                        <Card className="text-center">
                            <Card.Body>
                                <h4>No booking information found</h4>
                                <p>Please use the invitation link sent to your email.</p>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    }

    return (
        <Container className="py-5">
            <Row className="justify-content-center">
                <Col md={8} lg={6}>
                    <Card className="text-center shadow">
                        <Card.Header className="bg-success text-white">
                            <h3><i className="bi bi-check-circle me-2"></i>Booking Confirmed!</h3>
                        </Card.Header>
                        <Card.Body className="py-4">
                            <div className="mb-4">
                                <i className="bi bi-calendar-check" style={{ fontSize: '4rem', color: '#28a745' }}></i>
                            </div>
                            
                            <h4 className="mb-3">Your interview has been successfully scheduled</h4>
                            
                            <div className="bg-light p-3 rounded mb-4">
                                <h5><i className="bi bi-calendar-event me-2"></i>Interview Details</h5>
                                <p className="mb-2">
                                    <strong>Date & Time:</strong><br/>
                                    {new Date(slotDateTime).toLocaleDateString('en-US', {
                                        weekday: 'long',
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric'
                                    })}<br/>
                                    {new Date(slotDateTime).toLocaleTimeString('en-US', {
                                        hour: '2-digit',
                                        minute: '2-digit'
                                    })}
                                </p>
                            </div>

                            {meetingLink && (
                                <div className="mb-4">
                                    <Button
                                        as="a"
                                        href={meetingLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        variant="primary"
                                        size="lg"
                                    >
                                        <i className="bi bi-camera-video me-2"></i>
                                        Join Interview Meeting
                                    </Button>
                                </div>
                            )}

                            <div className="alert alert-info text-start">
                                <h6><i className="bi bi-info-circle me-2"></i>Important Reminders:</h6>
                                <ul className="mb-0">
                                    <li>Join the meeting 5 minutes before the scheduled time</li>
                                    <li>Ensure you have a stable internet connection</li>
                                    <li>Test your camera and microphone beforehand</li>
                                    <li>Keep a copy of your resume ready</li>
                                    <li>Find a quiet, well-lit space for the interview</li>
                                </ul>
                            </div>

                            <div className="alert alert-success">
                                <i className="bi bi-envelope-check me-2"></i>
                                A confirmation email has been sent to your registered email address with all the details.
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default BookingConfirmation;
